import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { fadeSlideIn } from '../animation';
import { InsuranceOptionsGroup } from './InsuranceRateElementDetailView/components';
import { IconName, SideOverHeaderNew, SideOverHeading } from '../components';
import { InsurancePolicySubtype, InsurancePolicyType } from '../../generated/graphql';

interface AddInsuranceOptionsPageProps {
  heading?: string;
  exitText?: string;
  exitIcon?: IconName;
}

export function AddInsuranceOptionsPage({ exitIcon, exitText, heading }: AddInsuranceOptionsPageProps) {
  const { t } = useTranslation('insurance');
  const { t: tCommon } = useTranslation('common');

  return (
    <div>
      <SideOverHeaderNew
        withShadow
        className="pl-4 mt-0"
        exitIcon={exitIcon ?? 'back'}
        exitText={exitText ?? tCommon('back')}
      />
      <div className="px-12">
        <SideOverHeading className="mb-4" heading={heading ?? t('add-insurance-policy')} />
        <motion.div key="InsuranceView_body" {...fadeSlideIn()}>
          <InsuranceOptionsGroup
            heading={InsurancePolicyType.Life}
            items={[
              InsurancePolicySubtype.Term,
              InsurancePolicySubtype.CashValue,
              InsurancePolicySubtype.BuySell,
              InsurancePolicySubtype.KeyPerson,
            ]}
          />
          <InsuranceOptionsGroup
            heading={InsurancePolicyType.Disability}
            items={[InsurancePolicySubtype.PersonalDisability, InsurancePolicySubtype.BusinessOverhead]}
          />
          <InsuranceOptionsGroup
            heading={InsurancePolicyType.Liability}
            items={[
              InsurancePolicySubtype.PersonalUmbrella,
              InsurancePolicySubtype.Malpractice,
              InsurancePolicySubtype.BusinessLiability,
            ]}
          />
        </motion.div>
      </div>
    </div>
  );
}
